import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orgInfoFn, depListFn } from '@/api/org/dep';
import { sysInfoFn as _sysInfoFn } from '@/api/org/per';
// 部门列表
import JobSelect from '_c/jobSelect';
export default {
  name: 'searchPopup',
  props: ['drawer'],
  components: {
    JobSelect: JobSelect
  },
  data: function data() {
    return {
      visible: false,
      popover: false,
      treeList: [],
      name: '',
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      treeCheckList: [],
      dataForm: {
        hireDate: '',
        leaveDate: '',
        job_title_id: '',
        department_id: '',
        settlement_type: [],
        formal: [],
        state: [],
        begin_hire_date: '',
        end_hire_date: '',
        begin_leave_date: '',
        end_leave_date: ''
      },
      settlement_type: [],
      formal: [],
      state: [],
      sysInfoData: {},
      isSubmit: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.visible = true;
      this.sysInfoFn();
      this.getOrgInfo();
      this.defaultCheckedKeys = this.treeCheckList;
      if (sessionStorage.getItem('searchResult')) {
        var searchValue = JSON.parse(sessionStorage.getItem('searchResult'));
        this.defaultCheckedKeys = searchValue.default_checked_keys.map(function (i) {
          return i.department_id;
        });
        Object.keys(this.dataForm).map(function (item) {
          if (item === 'department_id') return;
          _this2.dataForm[item] = searchValue[item];
        });
        this.handleState();
      }
    },
    // 获取选项
    sysInfoFn: function sysInfoFn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) _this3.sysInfoData = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleNodeClick: function handleNodeClick(data) {
      this.dataForm.department_id = data.department_id; // 选中节点
      this.treeCheckList = [data];
    },
    // 删除节点
    departmentClear: function departmentClear() {
      this.dataForm.department_id = ''; // 选中节点
      this.treeCheckList.splice(0, 1);
      this.$refs.tree.setCheckedNodes(this.treeCheckList);
    },
    beforeunloadHandler: function beforeunloadHandler() {
      sessionStorage.removeItem('searchResult');
    },
    settlementTypeChange: function settlementTypeChange() {
      if (this.dataForm.settlement_type.length > 1) {
        this.dataForm.settlement_type.shift();
      }
    },
    formalChange: function formalChange() {
      if (this.dataForm.formal.length > 1) {
        this.dataForm.formal.shift();
      }
    },
    getOrgInfo: function getOrgInfo() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, obj;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return orgInfoFn();
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this4.isShowTips = !res.data.supervisor_id;
                obj = {
                  department_name: res.data.department_name,
                  department_id: Number(res.data.id),
                  supervisor_id: res.data.supervisor_id,
                  supervisor_name: res.data.supervisor_name
                };
                _this4.defaultExpandedKeys.push(Number(res.data.id));
                _this4.curNode = obj;
                _this4.treeList = [_objectSpread({
                  is_sub_department: false
                }, obj)];
                _this4.tableData = [_objectSpread(_objectSpread({}, obj), {}, {
                  is_sub_department: true
                })];
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 入职时间
    hireDateChange: function hireDateChange(v) {
      this.handleData(v, 'begin_hire_date', 'end_hire_date');
    },
    // 离职时间
    leaveDateChange: function leaveDateChange(v) {
      this.handleData(v, 'begin_leave_date', 'end_leave_date');
    },
    // 修改时间
    handleData: function handleData(v, beding, finish) {
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.dataForm[beding] = start;
        this.dataForm[finish] = end;
      } else {
        this.dataForm[beding] = '';
        this.dataForm[finish] = '';
      }
    },
    loadNode: function loadNode(node, resolve) {
      var _this5 = this;
      if (node.data.department_id) {
        this.hasDepListFn = true;
        depListFn({
          department_id: node.data.department_id
        }).then(function (res) {
          _this5.hasDepListFn = false;
          _this5.tableData = res.data;
          resolve(res.data.map(function (v) {
            return {
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              staff_count: v.staff_count
            };
          }));
        });
      }
    },
    handleProcessData: function handleProcessData(data) {
      this.dataForm.settlement_type = this.dataForm.settlement_type.toString();
      this.dataForm.formal = this.dataForm.formal.toString();
      // this.dataForm.state = this.dataForm.state.toString()
      return data;
    },
    handleState: function handleState() {
      // 包含离职时，可选择离职日期
      if (this.drawer.type === '50tawi') {
        this.drawer.leave_date = false;
        if (this.dataForm.state.includes('2')) this.drawer.leave_date = true;
      }
    },
    // 重置
    doReset: function doReset() {
      this.isSubmit = false;
      this.beforeunloadHandler();
      this.$refs.tree.setCheckedKeys([]);
      this.dataForm.end_leave_date = '';
      this.dataForm.begin_leave_date = '';
      this.dataForm.end_hire_date = '';
      this.dataForm.begin_hire_date = '';
      this.dataForm.job_title_id = '';
      this.dataForm.hireDate = '';
      this.dataForm.leaveDate = '';
      this.dataForm.formal = [];
      this.dataForm.state = [];
      this.dataForm.settlement_type = [];
      this.treeCheckList = [];
      this.dataForm.department_id = '';
      this.$refs.jobSelect._data.selectValue = '';
      this.handleState();
    },
    closeDrawer: function closeDrawer() {
      if (!this.isSubmit) this.doReset();
    },
    doSubmit: function doSubmit() {
      this.isSubmit = true;
      var searchResult = {
        default_checked_keys: this.$refs.tree.getCheckedNodes(),
        settlement_type: this.dataForm.settlement_type,
        formal: this.dataForm.formal,
        state: this.dataForm.state,
        hireDate: this.dataForm.hireDate,
        leaveDate: this.dataForm.leaveDate,
        begin_hire_date: this.dataForm.begin_hire_date,
        end_hire_date: this.dataForm.end_hire_date,
        begin_leave_date: this.dataForm.begin_leave_date,
        end_leave_date: this.dataForm.end_leave_date
      };
      sessionStorage.removeItem('searchResult');
      sessionStorage.setItem('searchResult', JSON.stringify(searchResult));
      this.handleProcessData();
      this.visible = false;
      this.$emit('submit', this.dataForm);
    },
    destroyed: function destroyed() {
      var _this6 = this;
      window.removeEventListener('beforeunload', function (e) {
        return _this6.beforeunloadHandler(e);
      });
    }
  }
};